import { styled } from '@mui/material';
import MuiTablePaginationActions from '@mui/material/TablePaginationActions';

import { CompactPaginationItem } from '../CompactPaginationItem';
import { PaginationDisplayedRows } from '../PaginationDisplayedRows';
import { compactPaginationClasses } from './theme';

import type { CompactPaginationItemProps } from '../CompactPaginationItem';
import type { CompactPaginationProps } from './types';

const CompactPagination = (props: CompactPaginationProps) => {
  const {
    page,
    count,
    rowsPerPage,
    hideLabelDisplayRows,
    renderLabelDisplayedRows,
    hasMore,
    slots,
    slotProps,
    ...others
  } = props;

  return (
    <CompactPaginationRoot>
      {!hideLabelDisplayRows && (
        <PaginationDisplayedRows
          page={page}
          count={count}
          rowsPerPage={rowsPerPage}
          hasMore={hasMore}
          renderLabelDisplayedRows={renderLabelDisplayedRows}
        />
      )}
      <CompactPaginationActions
        {...others}
        slots={{
          nextButton: CompactPaginationItem,
          previousButton: CompactPaginationItem,
          ...slots,
        }}
        slotProps={
          {
            nextButton: { type: 'next', ...slotProps?.nextButton } as CompactPaginationItemProps,
            previousButton: {
              type: 'previous',
              ...slotProps?.previousButton,
            } as CompactPaginationItemProps,
          } as any
        }
        getItemAriaLabel={type => {
          return `Go to ${type} page`;
        }}
        page={page}
        // hasMore=true면 다음 페이지가 있으므로 count=-1로 전달 (MUI 정책: count=-1이면 다음 버튼 무조건 활성화)
        count={hasMore ? -1 : count}
        rowsPerPage={rowsPerPage}
        showFirstButton={false}
        showLastButton={false}
      />
    </CompactPaginationRoot>
  );
};

export default CompactPagination;

const CompactPaginationRoot = styled('div', {
  target: compactPaginationClasses.root,
})`
  display: flex;
  align-items: center;
  column-gap: 12px;
`;

const CompactPaginationActions = styled(MuiTablePaginationActions, {
  target: compactPaginationClasses.actions,
})`
  display: flex;
  column-gap: 6px;
`;
